import { render, staticRenderFns } from "./ScienceBreadcrumb.vue?vue&type=template&id=06fc09fa&"
import script from "./ScienceBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./ScienceBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./ScienceBreadcrumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports